/** Typed permission names. The ONLY vocabulary components may gate on. */
export const PERM = {
  VENDOR_SELECT: 'vendor:select',
  CONSULTATION_TOGGLE: 'consultation:toggle',
  PRICING_VIEW: 'pricing:view',          // BOM, pricing cards, Solution Price, Hardware Reference
  RATES_EDIT: 'rates:edit',              // SSD/HDD software $, discount months (Special Pricing card)
  QUARTER_ALL: 'quarter:all',            // non-current quarters in the picker
  ADMIN_SKUS: 'sku:adminOnly',           // adminOnly SKUs (QLC), 12/24-month terms
  QUOTE_GENERATE: 'quote:generate',      // Quote Details + Generate Quote PDF + S3/CSV export
  SUMMARY_PDF: 'pdf:summary',
  EXEC_CUSTOM_PRICING: 'exec:customPricing',
  EXEC_CUSTOM_METRICS: 'exec:customMetrics', // CONF-212: the exec Custom Metrics panel
  FLASH_DUAL_CPU: 'flash:dualCpu',       // CONF-210: choose the Dual CPU flash node (dualCpuAccess, CONF-259)
  LOAD_TOTAL_COST: 'load:totalCost',     // Total Cost column in the Load modal
  ADMIN_VIEW: 'admin:view',
  ADMIN_MANAGE: 'admin:manage',       // adminAccess only — audit, users, account execs
  CATALOG_AUTHOR: 'catalog:author',
} as const;

export type Perm = (typeof PERM)[keyof typeof PERM];
